
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class MigrationBlock extends Vue {
  @Prop({ default: () => ({}) }) info!: any;

  redirectSeconds = 0;
  private redirectTimer = 0;

  mounted(): void {
    // 完成期且配置了新平台地址：倒计时后自动跳转
    if (this.phase >= 3 && this.newPlatformUrl) {
      this.redirectSeconds = 5;
      this.redirectTimer = window.setInterval(() => {
        this.redirectSeconds -= 1;
        if (this.redirectSeconds <= 0) {
          clearInterval(this.redirectTimer);
          this.gotoNewPlatform();
        }
      }, 1000);
    }
  }

  beforeDestroy(): void {
    if (this.redirectTimer) {
      clearInterval(this.redirectTimer);
    }
  }

  get phase(): number {
    return Number(this.info.phase || 2);
  }
  get cutoverStart(): number {
    return Number(this.info.cutover_start || 0);
  }
  get cutoverEnd(): number {
    return Number(this.info.cutover_end || 0);
  }
  get noticeText(): string {
    return String(this.info.notice_text || '');
  }
  get newPlatformUrl(): string {
    return String(this.info.new_platform_url || '');
  }

  formatTime(ts: number): string {
    if (!ts) return '--';
    const d = new Date(ts * 1000);
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  gotoNewPlatform(): void {
    if (this.newPlatformUrl) {
      window.location.href = this.newPlatformUrl;
    }
  }
}
